import React from 'react';

export const FavouriteButton = ({active, onClick}) => (
    <button
        className={`favouriteButton ${active ? 'active' : ''}`}
        onClick={onClick}
    >
        <svg
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="white"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d={
                    active ?
                        "M7.45 13.975L5.825 21L12 17.275L18.175 21L16.55 13.975L22 9.25L14.8 8.625L12 2L9.2 8.625L2 9.25L7.45 13.975ZM11.9423 12.5211L12 12.4863L12.0577 12.5215L12.0426 12.4556L12.0934 12.4116L12.0266 12.4057L12 12.3434L11.9734 12.4052L11.9066 12.4112L11.9574 12.4556L11.9423 12.5211Z"
                        :
                        "M7.45 13.975L5.825 21L12 17.275L18.175 21L16.55 13.975L22 9.25L14.8 8.625L12 2L9.2 8.625L2 9.25L7.45 13.975ZM7.13149 19.1573L12 16.2208L16.8685 19.196L15.5934 13.632L19.8824 9.92261L14.2411 9.4203L12 4.1654L9.75894 9.38166L4.11765 9.88397L8.40657 13.632L7.13149 19.1573Z"
                }
                fill="#E8EAED"
            />
        </svg>
    </button>
);